import { useWalletModal } from './WalletModalContext';
import '../styles/HeroIntro.css';

function HeroIntro() {
  const { open } = useWalletModal();
  const iconUrl = `${process.env.PUBLIC_URL}/images/logoo.svg`;
  const splashUrl = `${process.env.PUBLIC_URL}/images/splash-graphic.png`;

  return (
    <section className="hero-intro">
      <div className="hero-intro__card">
        <img src={iconUrl} alt="" className="hero-intro__icon" />
        <h2 className="hero-intro__heading">The blockchain for data</h2>
        <p className="hero-intro__subtext">
           Having trouble with FLR, WFLR, FXRP, stXRP, sFLR or stFLR - staking, FAssets, bridging or wallet issues? Our support portal helps you diagnose and fix every issue fast.
        </p>

        <div className="hero-intro__splash-wrap">
          <img src={splashUrl} alt="" className="hero-intro__splash" />
          <button className="hero-intro__cta hero-intro__cta--on-image" onClick={open}>
            Connect Wallet
          </button>
        </div>
      </div>
    </section>
  );
}

export default HeroIntro;